import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ApmRoutes } from '@elastic/apm-rum-react'

import { GlobalStyle } from "@swegon/sds-core";
import { SdsSetup, SdsWrapper } from "./Sds";

import ApplicationRoutes from "./routes/ApplicationRoutes";
import Login from "./pages/Login";
import SignOut from "./pages/SignOut";
import SignedOn from "./pages/SignedOn";
import AuthorizationRoute from "./routes/AuthorizationRoute";

import NotFound from "./pages/NotFound";
import NoAccess from "./pages/NoAccess";

const basename = process.env.SDS_APP_PREFIX;

const App = () => (
    <SdsSetup>
        <Router basename={basename}>
            <div className='App'>
                <GlobalStyle />
                <SdsWrapper>
                    <ApmRoutes>
                        <Route path='/login' element={<Login />} />
                        <Route path='/signout' element={<SignOut />} />
                        <Route path='/noAcess' element={<NoAccess />} />
                        <Route path='/Forbidden' element={<NoAccess />} />
                        <Route exact path= '/*' element={<AuthorizationRoute component={ApplicationRoutes} />} />
                        <Route path='/authorized' element={<SignedOn />} />
                        <Route path='*' element={<NotFound />} />
                    </ApmRoutes>
                </SdsWrapper>
            </div>
        </Router>
    </SdsSetup>
);
export default App;
